import React from 'react'
import utils from '../../../../../components/Organisms/Form/utils'
import { Trans } from 'react-i18next'
import Label from 'src/components/Atoms/Label/Label'
import Font from 'src/components/Core/Typography/Font/Font'

const FCOrNFCNo = (
  <Font
    key='FCOrNFCNo'
    ellipsis={false}
    margin='0 0 8px 0'
  >
    {/* @ts-ignore:next-line */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.EmirTradeReportingForm.visualOnly.fcOrNFCNo.content'}/>
  </Font>
)

const config = utils.injectTranslation({
  id: 'DelegatedTradeReporting',
  path: 'onboarding.forms.CorporateAccount.EmirTradeReportingForm.inputs',
  content: [
    {
      path: 'onboarding.forms.CorporateAccount.EmirTradeReportingForm.inputs',
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          props: {
            name: 'isIncorporatedInUK',
            dataList: [
              {
                id: 'isIncorporatedInUK1',
                label: <Label label={<Trans i18nKey={'components.forms.labels.yes'}/>} />,
                value: 'true',
              },
              {
                id: 'isIncorporatedInUK2',
                label: <Label label={<Trans i18nKey={'components.forms.labels.no'}/>} />,
                value: 'false',
              },
            ],
            required: true,
            responsive: true,
            flexProperties: {
              alignItems: 'flex-start'
            },
            minHeight: '80px',
            margin: '32px 0 0 0',
            marginBottom: '4px'
          },
        },
        {
          componentType: 'radioGroup',
          props: {
            name: 'areYouFCOrNFCPlus',
            dataList: [
              {
                id: 'areYouFCOrNFCPlus1',
                label: <Label label={<Trans i18nKey={'components.forms.labels.yes'}/>} />,
                value: 'true',
              },
              {
                id: 'areYouFCOrNFCPlus2',
                label: <Label label={<Trans i18nKey={'components.forms.labels.no'}/>} />,
                value: 'false',
              },
            ],
            required: true,
            responsive: true,
            flexProperties: {
              alignItems: 'flex-start'
            },
            minHeight: '80px',
            marginBottom: '4px'
          },
        },
        {
          componentType: 'radioGroup',
          props: {
            name: 'doYouDelegateTrade',
            dataList: [
              {
                id: 'doYouDelegateTrade1',
                label: <Label label={<Trans i18nKey={'onboarding.forms.CorporateAccount.EmirTradeReportingForm.radioOpts.yes'}/>} />,
                value: 'true',
              },
              {
                id: 'doYouDelegateTrade2',
                label: <Label label={<Trans i18nKey={'onboarding.forms.CorporateAccount.EmirTradeReportingForm.radioOpts.no'}/>} />,
                value: 'false',
              },
            ],
            required: true,
            responsive: true,
            flexProperties: {
              alignItems: 'flex-start'
            },
            minHeight: '80px',
            marginBottom: '4px'
          },
        },
        {
          componentType: '',
          visualComponent: FCOrNFCNo,
          visualName: 'fCOrNFCNo'
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'otcDerivatives',
            labelProps: {
              labelWhiteSpace: 'pre-wrap',
              bold: true
            },
          },
        },
        {
          componentType: 'radioGroup',
          props: {
            name: 'otcDerivativesReportOption',
            dataList: [
              {
                id: 'otcDerivativesReportOption1',
                label: <Label label={<Trans i18nKey={'onboarding.forms.CorporateAccount.EmirTradeReportingForm.radioOpts.yes'}/>} />,
                value: 'true-uk',
              },
              {
                id: 'otcDerivativesReportOption2',
                label: <Label label={<Trans i18nKey={'onboarding.forms.CorporateAccount.EmirTradeReportingForm.radioOpts.no'}/>} />,
                value: 'false-uk',
              },
            ],
            responsive: true,
            flexProperties: {
              alignItems: 'flex-start'
            },
            margin: '0 0 16px 4%',
            removeLabelEllipsis: true

          },
        },
        {
          componentType: 'radioGroup',
          props: {
            skipLabel: true,
            name: 'otcDerivativesReportOption',
            label: <Label label={<Trans i18nKey={'onboarding.forms.CorporateAccount.EmirTradeReportingForm.inputs.otcDerivativesReportOption.eeaBased'}/>} />,
            dataList: [
              {
                id: 'otcDerivativesReportOption3',
                label: <Label label={<Trans i18nKey={'onboarding.forms.CorporateAccount.EmirTradeReportingForm.radioOpts.yes'}/>} />,
                value: 'true-eea',
              },
              {
                id: 'otcDerivativesReportOption4',
                label: <Label label={<Trans i18nKey={'onboarding.forms.CorporateAccount.EmirTradeReportingForm.radioOpts.no'}/>} />,
                value: 'false-eea',
              },
            ],
            responsive: true,
            flexProperties: {
              alignItems: 'flex-start'
            },
            minHeight: '80px',
            margin: '0 0 24px 4%',
            removeLabelEllipsis: true
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'exchangeTradedDerivatives',
            labelProps: {
              labelWhiteSpace: 'pre-wrap',
              bold: true
            },
          },
        },
        {
          componentType: 'radioGroup',
          props: {
            name: 'exchangeTradeDerivativesReportOption',
            dataList: [
              {
                id: 'exchangeTradedDerivativesReportOption1',
                label: <Label label={<Trans i18nKey={'onboarding.forms.CorporateAccount.EmirTradeReportingForm.radioOpts.yes'}/>} />,
                value: 'true',
              },
              {
                id: 'exchangeTradeDerivativesReportOption2',
                label: <Label label={<Trans i18nKey={'onboarding.forms.CorporateAccount.EmirTradeReportingForm.radioOpts.no'}/>} />,
                value: 'false',
              },
            ],
            required: true,
            responsive: true,
            flexProperties: {
              alignItems: 'flex-start'
            },
            margin: '0 0 32px 4%',
            removeLabelEllipsis: true
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'vatNumber',
            required: true,
          },
        },
      ],
    },
  ],
})

export default config
